export default () => {
    return localStorage.getItem('language') || 'zh-hk';
}